/**
 * Get the base URL
 */
import $ from "dabbyjs/src/core/dabby/dabby.js";
import "dabbyjs/src/attributes/attr/attr.js";
import absoluteUrl from "./absolute-url.js";

let base;

export default () => {
	if (!base) {
		const prefix = absoluteUrl($("script[src*='javascript/']").attr("src")).match(/^(.*)javascript\//);
		base = prefix[1];
	}
	return base;
};
